import Addchart from "@mui/icons-material/Addchart";
import { type FC, useCallback } from "react";
import { useLexicalContext } from "../../../lexical-context";
import type { ToolbarProps } from "../props";
import { ToolbarIconButton } from "../toolbar-icon-button";

export const PollButton: FC<ToolbarProps & { label: string; onClose?: () => void }> = ({
  disabled,
  label,
  onClose,
}) => {
  const {
    editorModal: { handleOpen },
  } = useLexicalContext();

  const onClick = useCallback(() => {
    handleOpen({ type: "poll", data: { mode: "add" } });
    onClose?.();
  }, [handleOpen, onClose]);

  return (
    <ToolbarIconButton
      data-analytics-id="lexical-toolbar-add-poll"
      sx={{ justifyContent: "start" }}
      disabled={disabled}
      label={label}
      icon={<Addchart fontSize="medium" />}
      data-testid="toolar-button-add-poll"
      aria-label={label}
      tabIndex={-1}
      onClick={onClick}
    />
  );
};
